import { useEffect, useMemo } from "react";
import Footer from "../../components/layouts/Footer";
import MailingList from "../../components/MailingList";
import OurTeam from "../../components/OurTeam";
import UserTestimonials from "../../components/UserTestimonials";
import { Link, useLocation } from "react-router-dom";

function AboutUs() {
  const location = useLocation();
  const testimonialsData = useMemo(
    () => [
      {
        name: "Wade Warren",
        designation: "CEO at Vision Trust",
        description:
          "It is a long established fact that a reader will be cted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal.",
        image: "/assets/imgs/slider_bg.png",
      },
      {
        name: "Wade Warren",
        designation: "CEO at Vision Trust",
        description:
          "It is a long established fact that a reader will be cted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal.",
        image: "/assets/imgs/slider_bg.png",
      },
      {
        name: "Wade Warren",
        designation: "CEO at Vision Trust",
        description:
          "It is a long established fact that a reader will be cted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal.",
        image: "/assets/imgs/slider_bg.png",
      },
      {
        name: "Wade Warren",
        designation: "CEO at Vision Trust",
        description:
          "It is a long established fact that a reader will be cted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal.",
        image: "/assets/imgs/slider_bg.png",
      },
      {
        name: "Wade Warren",
        designation: "CEO at Vision Trust",
        description:
          "It is a long established fact that a reader will be cted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal.",
        image: "/assets/imgs/slider_bg.png",
      },
      {
        name: "Wade Warren",
        designation: "CEO at Vision Trust",
        description:
          "It is a long established fact that a reader will be cted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal.",
        image: "/assets/imgs/slider_bg.png",
      },
    ],
    []
  );

  useEffect(() => {
    let s = location.search?.split("?to=")[1];
    if (s === "team") {
      document.getElementById("ourTeam")?.scrollIntoView();
    } else if (s === "testimonials") {
      document.getElementById("ourTestimonials")?.scrollIntoView();
    }
  }, [location.search]);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 px-sm-0 px-3">
            <div className="row">
              <div className="col-12">
                <hr className="my-4" style={{ opacity: "0.1" }} />
              </div>
              <div className="breadCrumb mt-4 mb-3">
                <div className="d-flex gap-3">
                  <Link to="/">
                    <p className="m-0">Home</p>
                  </Link>
                  <span>/</span>
                  <Link to="/about-us">
                    <h4>About Us</h4>
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-5">
                <img src="/assets/imgs/about-us.png" className="w-100" alt="" />
              </div>
              <div className="col-md-1"></div>
              <div className="col-md-6 my-auto aboutUsText">
                <h5 className="mt-md-0 mt-3">About Us</h5>
                <h2>Boll-e&trade;: Art, meeting its true value</h2>
                <p style={{ textAlign: "justify" }}>
                  At Boll-e&trade;, we believe every piece of art tells a story, and
                  our mission is to ensure those stories are valued to their
                  fullest potential. We are an innovative online marketplace
                  that connects artists, collectors, and art enthusiasts in a
                  secure and vibrant space where creativity meets commerce. Our
                  unique <strong>closed-bid auction system</strong> ensures that
                  sellers receive the highest possible value for their artwork,
                  while buyers engage in a fair and exciting bidding experience.
                  Each artwork on Boll-e&trade; is carefully vetted, providing
                  confidence and security for our users. Whether you're a
                  seasoned collector or a first-time bidder, Boll-e&trade; offers a
                  platform built on trust, transparency, and artistic integrity.
                </p>
                <p style={{ textAlign: "justify" }}>
                  With{" "}
                  <strong>verified accounts, transparent transactions</strong>,
                  and a strong commitment to fairness, Boll-e&trade; is your
                  destination for discovering and selling art at its true worth.
                  Our platform brings art to life, transcending boundaries and
                  allowing you to invest in creativity that resonates with your
                  soul. Join Boll-e&trade; and take your passion for art to{" "}
                  <strong>sky-high</strong> levels!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="pt-5">
        <ServedIntro />
      </div> */}
      <div className="container mt-5" id="ourTeam">
        <div className="row">
          <div className="col-12 px-sm-0 px-3">
            <div className="row">
              <div className="col-12">
                <OurTeam />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="mt-5 position-relative py-5"
        style={{ backgroundColor: "#F7F7F7" }}
      >
        <div className="container" id="ourTestimonials">
          <div className="row">
            <div className="col-12 px-md-0 px-3">
              <div className="row">
                <div className="col-lg-3 aboutUsText my-auto">
                  <h5>Testimonials</h5>
                  <h2>User testimonials: What our customers are saying</h2>
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-8 mt-lg-0 mt-4">
                  <UserTestimonials
                    uniqueId="userTestimonials"
                    slidesData={testimonialsData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container pt-4">
        <div className="row mx-0">
          <div className="col-md-11 mx-auto mb-4">
            <MailingList />
          </div>
        </div>
      </div> */}
      <Footer />
    </>
  );
}

export default AboutUs;
